import type { WallAiJob } from '@walls/store/wallAiJobStore';
import type { CardId, WallId } from '@walls/store/types';
import type { WallsClient } from './client';

export class AiApi {
  constructor(private readonly client: WallsClient) {}

  groupCardsByTheme = (
    boardId: WallId,
    cardIds: CardId[],
    layout: { height: number; width: number },
    key?: string | null
  ): Promise<WallAiJob> =>
    this.client.requestJson<WallAiJob>(
      `/boards/ai/group-themes/${boardId}`,
      boardId,
      key,
      {
        method: 'POST',
        body: JSON.stringify({ cardIds, layout }),
      }
    );

  getThemeGroupingJob = (
    boardId: WallId,
    key?: string | null
  ): Promise<WallAiJob | null> =>
    this.client.requestJson<WallAiJob | null>(
      `/boards/ai/group-themes/${boardId}/job`,
      boardId,
      key
    );
}
